'use strict';

/**
 *
 * @name: guestPicks
 *
 */

import DirectiveTemplate from './nn-guest-picks.directive.html';
import './nn-guest-picks.directive.scss';

function GuestsPicksDirective() {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    controller: guestsPicksDirectiveController,
    controllerAs: 'guestPicks'
  };
}

function guestsPicksDirectiveController(
  $scope,
  $rootScope,
  $element,
  transObject
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var guestPicks = this;
  guestPicks.content = $scope.content();
  guestPicks.title = guestPicks.content.title || 'Guest Picks';
  guestPicks.posts = [];
  guestPicks.user = guestPicks.content.users[0];

  var noContent = !guestPicks.content.posts.length;

  /**
   *
   * @PUBLIC
   *
   */

  $scope.onAnalyticsClick = post => {
    $rootScope.analytics.videoAM('single series', guestPicks.content.title, post)
  }

  /**
   *
   * @PRIVATE
   *
   */

  function terminate() {

    $scope.$destroy();
    $element.remove();
  }

  function translatePosts() {

    return guestPicks.content.posts
      .map(function(post) {

        transObject.translate(post);
        transObject.trueSlug(post);
        transObject.getDuration(post);
        transObject.setBookmark(post);

        return post;
      });
  }

  function translateUser() {

    if (guestPicks.user) {

      transObject.trueSlug(guestPicks.user);

      guestPicks.user.proffesions = guestPicks.user.professions
        .map(function(prof) {

          transObject.translate(prof);
        });
    } else {
      guestPicks.user = {};
    }

    guestPicks.user.guestDescription = guestPicks.content.jsonData.guestDescription;
    guestPicks.user.guestImage = guestPicks.content.jsonData.guestImage;
    guestPicks.user.guestName = guestPicks.content.jsonData.guestName;
    guestPicks.user.guestProfessions = guestPicks.content.jsonData.guestProfessions;

    return guestPicks.user;
  }

  /**
   *
   * @INIT
   *
   */

  if (noContent) {

    terminate();
  } else {

    guestPicks.user = translateUser();
    guestPicks.posts = translatePosts();
  }
}

export default GuestsPicksDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-guest-picks/nn-guest-picks.directive.js